import { getData } from "./firebase";

const DASHBOARD_V2_SEEN_INTRO_KEY = "dashboardV2IntroSeen";
const DASHBOARD_V2_INTRO_URL = "https://introv2.drivee.ai/";
const DASHBOARD_V2_URL = "https://dashboard.drivee.ai/";

// Check the useDashboardV2 feature flag on the dealership (manager) account.
// Staff/supervisors/etc. must always be checked against their manager's uid,
// never their own. Dealers with useBothVersions keep using the current
// dashboard silently — no modal, no redirect.
export async function hasDashboardV2Access(dealerUid: string): Promise<boolean> {
  if (!dealerUid) return false;
  try {
    const features: any = await getData(`dealers/${dealerUid}/info/activeFeatures`);
    const useBothVersions = Array.isArray(features)
      ? features.includes("useBothVersions")
      : features?.useBothVersions === true;
    if (useBothVersions) return false;

    return Array.isArray(features)
      ? features.includes("useDashboardV2")
      : features?.useDashboardV2 === true;
  } catch (error) {
    console.log(error, "error checking useDashboardV2 feature");
    return false;
  }
}

// Send the user to the intro page the first time and straight to the v2
// dashboard every time after that.
export function redirectToDashboardV2() {
  if (localStorage.getItem(DASHBOARD_V2_SEEN_INTRO_KEY)) {
    window.location.replace(DASHBOARD_V2_URL);
  } else {
    localStorage.setItem(DASHBOARD_V2_SEEN_INTRO_KEY, "true");
    window.location.replace(DASHBOARD_V2_INTRO_URL);
  }
}
